export type GateType = 'g1' | 'g2' | 'g3' | 'g4' | 'g5';

// Gate color constants for consistent styling across components
export const gateColors: Record<GateType, string> = {
  g1: 'hsl(var(--chart-1))', // Blue
  g2: 'hsl(var(--chart-2))', // Green
  g3: 'hsl(var(--chart-3))', // Yellow  
  g4: 'hsl(var(--chart-4))', // Orange
  g5: 'hsl(var(--chart-5))', // Purple
};

// Gate background colors for badges (lighter variants)
export const gateBadgeColors: Record<GateType, string> = {
  g1: 'bg-chart-1',
  g2: 'bg-chart-2', 
  g3: 'bg-chart-3',
  g4: 'bg-chart-4',
  g5: 'bg-chart-5',
};

// Gate text colors for contrast
export const gateTextColors: Record<GateType, string> = {
  g1: 'text-chart-1-foreground',
  g2: 'text-chart-2-foreground',
  g3: 'text-chart-3-foreground', 
  g4: 'text-chart-4-foreground',
  g5: 'text-chart-5-foreground',
};